<template>
  <v-main class="mt-md-12 mt-8 mb-6">
    <div class="text-center my-2 blueGrey--text">
      <v-icon class=" blueGrey--text">monetization_on</v-icon>
      Анализ по годам
    </div>
    <v-row>
      <v-col cols="10" md="7">
        <v-card flat dark class="mx-auto blueDark mt-n4">
          <!-- <br>{{shop_list}}<br><br> -->
          <!-- {{data}}
          {{show}} -->
          <div v-for="el in Object.keys(keys)" :key="el">
            <template v-if="show && data[el] && data[el].characters.length">
              <!-- {{data[el].characters}} -->
              <D3BarChart
                class="pt-6"
                :config="chart_config"
                :datum="data[el].characters"
                :title="keys[el]"
              ></D3BarChart>
            </template>
          </div>
        </v-card>
      </v-col>
      <v-col cols="2" md="5">
        <v-chip-group multiple column v-model="shop_list">
          <v-chip
            label
            class="px-1 mt-0"
            color="orangeDark"
            active-class="blueMain white--text"
            v-for="item in shop_list_all"
            :value="item"
            :key="item"
          >
            {{ item.split("@")[0] }}
          </v-chip>
        </v-chip-group>
        <v-chip-group class="mt-3" multiple column v-model="month_list">
          <v-chip
            label
            class="px-1 mt-0"
            color="white"
            active-class="blueMain white--text"
            style="font-family: monospace;"
            v-for="item in month_list_all"
            :value="item"
            :key="item"
          >
            {{ item }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import { mapState } from "vuex";
import { D3BarChart } from "vue-d3-charts";
import axios from "axios";

export default {
  name: "Analysis",
  components: {
    D3BarChart
  },
  data: () => ({
    keys: {
      sales: "Продажи (млн.)",
      rolls: "Рулоны (шт.)",
      aver_check: "Средний чек (руб.)"
    },
    month_list: [],
    month_list_all: [
      "янв",
      "фев",
      "мар",
      "апр",
      "май",
      "июн",
      "июл",
      "авг",
      "сен",
      "окт",
      "ноя",
      "дек"
    ],
    month_list_all_mm: [
      "январь",
      "февраль",
      "март",
      "апрель",
      "май",
      "июнь",
      "июль",
      "август",
      "сентябрь",
      "октябрь",
      "ноябрь",
      "декабрь"
    ],
    data: {},
    shop_list: [],
    chart_config: {
      show: false,
      key: "key",
      currentKey: new Date().getFullYear(),
      values: ["value"],
      axis: {
        yTicks: 3
      },
      color: {
        default: "white",
        current: "orange"
      }
    }
  }),

  computed: {
    ...mapState(["domen", "totalInfo", "shopinfo", "date"]),

    shop_list_all() {
      return Object.values(this.shopinfo).map(el => el.shop);
    }
  },

  methods: {
    async get_data(key, shop_list) {
      // данные по годам
      // this.data[key] = [];
      return axios
        .post(this.domen + "/service/analysis_years", {
          key: key,
          shop_list: shop_list,
          month_list: this.month_list.map(
            el => this.month_list_all.indexOf(el) + 1
          )
        })
        .then(res => res.data)
        .then(json => {
          this.data = { ...this.data, [key]: json.response };
        })
        .catch(err => window.console.warn(err));
    },

    update_data() {
      this.show = false;
      this.data = {};
      // for (let el of Object.keys(this.keys)) this.get_data(el, this.shop_list);
      // this.show = true;
      Promise.all(
        Object.keys(this.keys).map(el => this.get_data(el, this.shop_list))
      );
      this.show = true;
    }
  },

  watch: {
    shop_list() {
      this.update_data();
    },

    month_list() {
      this.update_data();
    }
  },

  created: function() {
    for (let el of Object.keys(this.keys)) this.get_data(el, this.shop_list);
    this.show = true;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
